var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_819_20602)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_819_20602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_819_20602)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2221 10.36C18.5244 8.82168 21.2311 8.00061 24 8.00061C26.7689 8.00061 29.4756 8.82168 31.7779 10.36C34.0802 11.8983 35.8746 14.0848 36.9343 16.6429C37.9939 19.201 38.2712 22.0159 37.7311 24.7316C37.1909 27.4473 35.8576 29.9419 33.8998 31.8998L33.8998 31.8998L25.4145 40.3851C25.0395 40.7597 24.5311 40.9702 24.001 40.9702C23.4709 40.9702 22.9625 40.7597 22.5875 40.3851L14.1003 31.8998L14.1001 31.8996C12.1423 29.9417 10.8091 27.4472 10.269 24.7316C9.72883 22.0159 10.0061 19.201 11.0658 16.6429C12.1254 14.0848 13.9198 11.8983 16.2221 10.36ZM24 4.00061C20.44 4.00061 16.9599 5.05627 13.9998 7.03409C11.0398 9.01192 8.73267 11.8231 7.37027 15.1121C6.00786 18.4011 5.65135 22.0203 6.34581 25.5119C7.04026 29.0035 8.75451 32.2108 11.2718 34.7282L11.272 34.7284L19.76 43.2144L19.7605 43.215C20.8856 44.3389 22.4108 44.9702 24.001 44.9702C25.5913 44.9702 27.1165 44.3389 28.2415 43.215L28.2422 43.2142L36.7282 34.7282L36.7283 34.7282C39.2455 32.2108 40.9598 29.0035 41.6542 25.5119C42.3487 22.0203 41.9922 18.4011 40.6297 15.1121C39.2673 11.8231 36.9602 9.01192 34.0002 7.03409C31.0401 5.05627 27.56 4.00061 24 4.00061ZM24 14C21.8783 14 19.8434 14.8429 18.3431 16.3431C16.8429 17.8434 16 19.8783 16 22C16 24.1217 16.8429 26.1566 18.3431 27.6569C19.8434 29.1571 21.8783 30 24 30C26.1217 30 28.1566 29.1571 29.6569 27.6569C31.1571 26.1566 32 24.1217 32 22C32 19.8783 31.1571 17.8434 29.6569 16.3431C28.1566 14.8429 26.1217 14 24 14ZM21.1716 19.1716C21.9217 18.4214 22.9391 18 24 18C25.0609 18 26.0783 18.4214 26.8284 19.1716C27.5786 19.9217 28 20.9391 28 22C28 23.0609 27.5786 24.0783 26.8284 24.8284C26.0783 25.5786 25.0609 26 24 26C22.9391 26 21.9217 25.5786 21.1716 24.8284C20.4214 24.0783 20 23.0609 20 22C20 20.9391 20.4214 19.9217 21.1716 19.1716Z",
    fill: "#1E293B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_819_20602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.21b3320f5b893ad1c70c963e1763a049.svg";
export { ForwardRef as ReactComponent };